import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesAddressEditMain } from './modules/ui/Main';

const AddressEditPage = (
  <SuspensePage>
    <PagesAddressEditMain />
  </SuspensePage>
);

export default AddressEditPage;
